import React from "react";
import { FaFilePdf } from "react-icons/fa";
import { useCartorio } from "../../../../Hooks/cartorio";
import { IComunicacao } from "../../../../Hooks/comunicacoes";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import theme from "../../../../Styles/theme";
import {
  baseUrlApiNotoficacoes,
  base_url_api_comunicacao,
} from "../../../../Utils/baseUrl";
import {
  ContainerMessage,
  Container,
  SpanDate,
  Imagem,
  ButtonPdfView,
} from "./styles";

interface Props {
  message: IComunicacao;
}

export function CardMessage({ message }: Props) {
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { cartorioIsLogged } = useCartorio();
  const { prefeituraIsLogged } = usePrefeitura();

  function defineMyMessage() {
    if (funcionarioCartorioIsLogged || cartorioIsLogged) {
      if (message.FUNCIONARIO_CARTORIO_ID || message.CARTORIO_ID) {
        return true;
      } else {
        return false;
      }
    }

    if (funcionarioPrefeituraIsLogged || prefeituraIsLogged) {
      if (message.FUNCIONARIO_PREFEITURA_ID) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  function renderAnexo() {
    if (message.IDENTIFICADOR) {
      if (
        message.IDENTIFICADOR.substring(
          message.IDENTIFICADOR.length - 3
        ).toLowerCase() == "pdf"
      ) {
        return (
          <ButtonPdfView
            onClick={() =>
              window.open(
                `${base_url_api_comunicacao}/anexos/${message.IDENTIFICADOR}`
              )
            }
          >
            <FaFilePdf size={"max(12px, 1.2vw)"} color={theme.colors.dark} />
          </ButtonPdfView>
        );
      } else {
        // window.open(`${base_url_api_comunicacao}/anexos/${message.IDENTIFICADOR}`)
        return (
          <Imagem
            src={`${base_url_api_comunicacao}/anexos/${message.IDENTIFICADOR}`}
            alt="IMAGEM"
            onClick={() =>
              window.open(
                `${base_url_api_comunicacao}/anexos/${message.IDENTIFICADOR}`
              )
            }
          />
        );
      }
    }
  }

  return (
    <Container myMessage={defineMyMessage()}>
      <ContainerMessage myMessage={defineMyMessage()}>
        {message.MENSSAGEM}
        {renderAnexo()}
        <div>
          <SpanDate>
            {new Date(message.CRIACAO).toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </SpanDate>

        </div>
      </ContainerMessage>
    </Container>
  );
}
